import request from '../../../utils/request'




export const resourceTokenGenerate = (data: any) => {
  return request({
    url: '/api/design/resource/token',
    method: 'post',
    data
  })
}
export const getFontList = (params) => {
  return request({
    url: '/api/design-engine/font/pages',
    method: 'get',
    params
  })
}
export function resourcerFileUpload(file: File, folder_id?: number, corp_code?: number, tag_ids?: string, category_id?: number) {
  const formData = new FormData()
  formData.append('file', file)
  if (folder_id) {
    formData.append('folder_id', folder_id.toString())
  }
  if (corp_code) {
    formData.append('corp_code', corp_code.toString())
  }
  if (tag_ids) {
    formData.append('tag_ids', tag_ids)
  }
  if (category_id) {
    formData.append('category_id', category_id.toString())
  }
  return request({
    url: '/api/design/resource/file',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}
export const getUserResourcePages = (params: any) => {
  return request({
    url: '/api/design/resource/pages',
    method: 'get',
    params
  })
}
export function saveFont(data: Record<string, any>) {
  return request({
    url: '/api/design/saveFont',
    method: 'post',
    data,
    // baseURL: 'https://www.aishanyin.com'
  })
}

export const getTemplateData = (params: any) => {
  return request({
    url: `/api/design/template/data`,
    method: 'get',
    params
  })
}
export function saveCanvasDpi(data: Record<string, any>) {
  return request({
    url: '/api/saveCanvasDpi',
    method: 'post',
    data,
    // baseURL: 'https://www.aishanyin.com'
  })
}
export function getCanvasDpi(data: Record<string, any>) {
  return request({
    url: '/api/getCanvasDpi',
    method: 'post',
    data,
    // baseURL: 'https://www.aishanyin.com'
  })
}
export function searchbyimage(data: Record<string, any>) {
  return request({
    url: '/api/design/material/search-by-image',
    method: 'get',
    params: data,
  })
}
export function saveCanvasData(data: Record<string, any>) {
  return request({
    url: '/api/saveCanvasData',
    method: 'post',
    data,
  })
}

